import { render, staticRenderFns } from "./KnMiniFooter.vue?vue&type=template&id=7497a968"
import script from "./KnMiniFooter?vue&type=script&lang=js&external"
export * from "./KnMiniFooter?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports